import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button } from "../components/ui";
// import { MoreHorizontal } from "lucide-react";
import { useApp } from "../App";

function AppCard({ app }) {
  const navigate = useNavigate();
  const colors = ["bg-purple-100 text-purple-600", "bg-blue-100 text-blue-600", "bg-pink-100 text-pink-600", "bg-emerald-100 text-emerald-600"];
  const colorClass = colors[app.app_name.length % colors.length];
  const initials = app.app_name.substring(0, 2).toUpperCase();

  return (
    <Card
      className="flex flex-col h-full relative group hover:ring-1 hover:ring-grigora-500/20 transition-all duration-200"
      onClick={() => navigate(`/apps/${app.id}`)}
    >
      <div className="flex justify-between items-start mb-4">
        <div className={`w-14 h-14 rounded-xl ${colorClass} flex items-center justify-center text-lg font-bold shadow-sm overflow-hidden`}>
          {app.icon_url ? <img src={app.icon_url} alt={app.app_name} className="w-full h-full object-cover" /> : initials}
        </div>
      </div>
      <div className="flex-1">
        <h3 className="text-lg font-bold text-slate-900 group-hover:text-grigora-600 transition-colors mb-2">{app.app_name}</h3>
        <p className="text-sm text-slate-500 line-clamp-2 mb-4">{app.description || "No description"}</p>
        <div className="flex flex-wrap gap-2 mb-6">
          {(app.scopes || []).slice(0, 3).map((scope) => (
            <span key={scope} className="px-2 py-1 rounded-md bg-slate-50 border border-slate-200 text-[10px] font-mono text-slate-500">
              {scope}
            </span>
          ))}
          {(app.scopes || []).length > 3 && (
            <span className="px-2 py-1 rounded-md bg-slate-50 border border-slate-200 text-[10px] font-mono text-slate-400">
              +{app.scopes.length - 3}
            </span>
          )}
        </div>
      </div>
      <div className="pt-4 mt-auto border-t border-slate-50 flex items-center justify-end">
        <span className="text-[10px] text-slate-400 font-mono">{(app.client_id || "").substring(0, 16)}...</span>
      </div>
    </Card>
  );
}

export function AppsList() {
  const navigate = useNavigate();
  const { apps, loading } = useApp();
  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h2 className="text-2xl font-bold text-slate-900">My Apps</h2>
          <p className="text-slate-500 mt-1">Manage your integrations and extensions.</p>
        </div>
        <Button onClick={() => navigate("/apps/new")}>Create App</Button>
      </div>
      {loading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-xl p-6 animate-pulse min-h-[220px]">
              <div className="w-14 h-14 bg-slate-100 rounded-xl mb-4" />
              <div className="h-5 bg-slate-100 rounded w-2/3 mb-2" />
              <div className="h-4 bg-slate-50 rounded w-full" />
            </div>
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {apps.map((app) => (
            <AppCard key={app.id} app={app} />
          ))}
          <button
            onClick={() => navigate("/apps/new")}
            className="border-2 border-dashed border-slate-200 rounded-xl p-6 flex flex-col items-center justify-center text-slate-400 hover:border-grigora-400 hover:text-grigora-600 hover:bg-grigora-50/50 transition-all duration-200 min-h-[220px]"
          >
            <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mb-4">
              <span className="text-2xl font-light">+</span>
            </div>
            <span className="font-medium">Create New App</span>
          </button>
        </div>
      )}
    </div>
  );
}
